import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Datepicker from 'react-datepicker';
import InfoButton from '../../InfoButton';
import { defaultDateFormat } from '../../../utils/eventConstants';

import styles from './datePicker.scss';

const DatepickerInput = ({
    id,
    label,
    hiddenLabel,
    description,
    placeholder,
    onChange,
    selected,
    hoverText,
    minDate,
    maxDate,
    disabled,
    format,
    themeV3,
    className,
    'data-testid': dataTestId,
}) => {
    return (
        <div className={`${styles.datePicker} form-group form-group-xl ${description && 'description'} ${themeV3 ? styles.themeV3 : ''} ${className || ''}`} data-testid={dataTestId}>
            <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                {!themeV3 && label}
                {hoverText && <InfoButton hoverText={hoverText} />}
            </label>
            {description && (<small>{description}</small>)}
            <div className="input-wrapper">
                <Datepicker
                    className="form-control"
                    selected={selected}
                    placeholder={placeholder}
                    onChange={onChange}
                    minDate={minDate}
                    maxDate={maxDate}
                    disabled={disabled}
                    dateFormat={format}
                    locale="us"
                />
            </div>
        </div>
    );
};

DatepickerInput.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    hiddenLabel: PropTypes.bool,
    description: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    selected: PropTypes.instanceOf(moment).isRequired,
    hoverText: PropTypes.string,
    minDate: PropTypes.instanceOf(moment).isRequired,
    maxDate: PropTypes.instanceOf(moment).isRequired,
    disabled: PropTypes.bool,
    format: PropTypes.string,
    themeV3: PropTypes.bool,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
};

DatepickerInput.defaultProps = {
    id: '',
    label: '',
    description: '',
    placeholder: '',
    hiddenLabel: false,
    hoverText: '',
    onChange: null,
    disabled: false,
    themeV3: false,
    className: '',
    format: defaultDateFormat,
    'data-testid': undefined,
};

export default DatepickerInput;
